
export const RecaptchaDisclaimer = () => {
  return (
    <div className="text-xs text-gray-400 text-center mt-4">
      This site is protected by reCAPTCHA and the Google{' '}
      <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">
        Privacy Policy
      </a>{' '}
      and{' '}
      <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">
        Terms of Service
      </a>{' '}
      apply.
    </div>
  );
};
